export default {
  default: () => import("/Users/eimei/Documents/projects/stack3webapp/layouts/default.vue").then(m => m.default || m),
  error: () => import("/Users/eimei/Documents/projects/stack3webapp/layouts/error.vue").then(m => m.default || m),
  plain: () => import("/Users/eimei/Documents/projects/stack3webapp/layouts/plain.vue").then(m => m.default || m),
  policy: () => import("/Users/eimei/Documents/projects/stack3webapp/layouts/policy.vue").then(m => m.default || m)
}